var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},_vm._l((_vm.productCategories),function(item){return (item.products.length > 0)?_c('accordion-catering-wrapper',{key:item.id,attrs:{"is-open":_vm.isOpen,"product_id":_vm.product_id,"products":item.products,"label":item.name,"desc":item.description}}):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }